import React from 'react';
import PropTypes from 'prop-types';

import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';

const image = require('./scantouch_logo.png');

export default class NavigationBar extends React.Component {
    static propTypes = {
        children: PropTypes.element,
        history: PropTypes.object,
        toggleNavigation: PropTypes.func,
    };

    render = () => {
        let cssStyle = {
            position: 'fixed',
            top: 0,
        };

        if (!this.props.topBar) {
            cssStyle = {};
        }

        return (
            <div>
                <AppBar
                    style={cssStyle}
                    title={
                        <img
                            src={image}
                            style={{
                                position: 'absolute',
                                width: '130px',
                                height: '30px',
                                top: '16px',
                            }}
                        />
                    }
                    iconElementLeft={
                        <div>
                            {this.props.showNavigation && (
                                <IconButton
                                    iconStyle={{
                                        color: 'white',
                                    }}
                                    onClick={this.props.toggleNavigation}
                                    iconClassName="material-icons"
                                    tooltipPosition="bottom-center">
                                    {this.props.leftIcon}
                                </IconButton>
                            )}
                        </div>
                    }
                    iconElementRight={
                        <div style={{ color: '#fff', paddingTop: '15px', paddingRight: '10px' }}>
                            {this.props.iconElementRight}
                        </div>
                    }
                />
            </div>
        );
    };
}
